<div class="card p-3 d-flex flex-column gap-3 mt-2">
  <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <Button
        style="border: none; background-color: transparent"
        (click)="back()"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt=""
          width="40px"
        />
      </Button>
      <span
        class="text-black"
        style="font-size: 20px; font-weight: 500; margin-left: 15px"
        >Order Detail</span
      >
    </div>
    @if (detailOrder?.shipping === 'GOSEND' || detailOrder?.shipping === 'gosend') {
      <div class="d-flex flex-column align-items-end">
        <b>
          Shipping by
          <img
            src="https://storage.googleapis.com/komerce/assets/logo/Komship-by-komerce.svg"
            alt=""
            width="80px"
          />
        </b>
        <div class="d-flex gap-2 mt-2">
          <button class="btn btn-outline-primary" style="width: 100px" (click)="cancelRequest()">
            Cancel
          </button>
          <button
            class="btn btn-primary text-white"
            style="width: auto;"
            (click)="submitRequest()"
          >
            Request Pickup
          </button>
        </div>
      </div>
    }
  </div>

  <app-order-information
    [detailOrder]="detailOrder"
    [loading]="loading"
  />

  @if (detailOrder?.shipping !== 'GOSEND' && detailOrder?.shipping !== 'LION') {
    <app-shipping-info-default
      [detailOrder]="detailOrder"
      [loading]="loading"
      [awbHistory]="awbHistory"
      (openTrackReceipt)="openLacakResi()"
    />
  }

  @if (detailOrder?.shipping === 'GOSEND' || detailOrder?.shipping === 'LION') {
    <app-shipping-info-gosend
      [detailOrder]="detailOrder"
      [loading]="loading"
      [awbHistory]="awbHistory"
      (openTrackReceipt)="openLacakResi()"
      (copyAwb)="copyValue($event)"
      (trackPackage)="trackPack($event)"
    />
  }

  <app-payment-summary
    [detailOrder]="detailOrder"
    [loading]="loading"
    [orderDetails]="orderDetails"
    [totalPrice]="totalPrice"
  />
</div>
